import React from "react";
import { Input } from "../ui/Input";

interface TestingConfigPanelProps {
  title?: string;
  conversationKey: string;
  setConversationKey: (v: string) => void;
  sessionId: string;
  setSessionId: (v: string) => void;
  onSave?: () => Promise<void> | void;
  saving?: boolean;
}

function generateUUIDv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const TestingConfigPanel: React.FC<TestingConfigPanelProps> = ({
  title = "Testing Configuration",
  conversationKey,
  setConversationKey,
  sessionId,
  setSessionId,
  onSave,
  saving,
}) => {
  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-1">
            <Input
              label="Conversation Key"
              type="text"
              value={conversationKey}
              onChange={(e) => setConversationKey(e.target.value)}
              variant="default"
              placeholder="e.g., outbound_dme"
            />
          </div>
          <div className="md:col-span-2">
            <div className="flex gap-2">
              <Input
                label="Session ID"
                type="text"
                value={sessionId}
                onChange={(e) => setSessionId(e.target.value)}
                variant="default"
                className="flex-1"
                placeholder="UUID for testing session"
              />
              <button
                type="button"
                className="px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 text-sm"
                onClick={() => setSessionId(generateUUIDv4())}
              >
                Generate
              </button>
              {onSave && (
                <button
                  type="button"
                  className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50"
                  onClick={() => onSave()}
                  disabled={!!saving}
                >
                  {saving ? "Saving…" : "Save"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestingConfigPanel;
